import _actions_get from './_actions/get.js'
import _getters_main from './_getters/main.js'
import _getters_list_with_all from './_getters/list_with_all.js'
import _getters_list from './_getters/list.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_items from './_mutations/items.js'
import _mutations_cb from './_mutations/cb.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        cb: _mutations_cb,
        items: _mutations_items,
        loading: _mutations_loading,
    },
    getters:{
        list: _getters_list,
        list_with_all: _getters_list_with_all,
        main: _getters_main,
    },
    actions:{
        get: _actions_get,
    },
}